import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_fields_store_clean = createAsyncThunkSafe<string | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.GENERATION_FIELDS_STORE_CLEAN,
  async (generation_id: string): Promise<string> => {
    return await send_to_server(ENUM__network_event_client_to_server.GENERATION_FIELDS_STORE_CLEAN, generation_id);
  },
);

export function INIT_REMOTE__generation_fields_store_clean(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_fields_store_clean.pending, (state, action) => {})
    .addCase(REMOTE__generation_fields_store_clean.rejected, (state, action) => {})
    .addCase(REMOTE__generation_fields_store_clean.fulfilled, (state, action: PayloadAction<string | DTO_RESPONSE__error>) => {});
}
